<app-header></app-header>

<!-- Hero Start -->
<section class="bg-half bg-light d-table w-100"
  style="background: url('../../../../../assets/images/background/abt-3.png') center center;">
  <div class="bg-overlay bg-overlay-white"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-12 text-center">
        <div class="page-next-level">
          <h1 class="title">{{ 'Footer.AboutUs' | translate }}</h1>
          <div class="page-next">
            <nav aria-label="breadcrumb" class="d-inline-block">
              <ul class="breadcrumb bg-white rounded shadow mb-0">
                <li class="breadcrumb-item"><a href="#">{{ 'Home.Home' | translate }}</a> <i
                    class="uil uil-angle-{{'dir-icon' | translate}} px-2"></i></li>
                <li class="breadcrumb-item active "><a href="#">{{ 'Footer.AboutUs' | translate }}</a></li>
              </ul>
            </nav>
          </div>
        </div>
      </div> <!--end col-->
    </div><!--end row-->
  </div> <!--end container-->
</section><!--end section-->
<!-- Hero End -->

<!-- Shape Start -->
<div class="position-relative">
  <div class="shape overflow-hidden text-white">
    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!--Shape End-->


<section class="section">
  <div class="container">
    <div class="row align-items-center" id="counter">
      <div class="col-md-6">
        <img src="../../../../../assets/images/about/about2.png" class="img-fluid" alt="">
      </div><!--end col-->

      <div class="col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
        <div class="ms-lg-4">
          <div class="d-flex mb-4">
            <span class="text-primary h1 mb-0"><span class="counter-value display-1 fw-bold"
                data-target="15">7</span>+</span>
            <span class="h6 align-self-end ms-2">{{ 'Home.About.Years' | translate }} <br> {{ 'Home.About.Experience' |
              translate }}</span>
          </div>
          <div class="section-title">
            <h4 class="title mb-4">{{ 'Home.About.WhoWe' | translate }}</h4>
            <p class="text-muted">{{ 'Home.About.WhoWeP1' | translate }}</p>
            <p class="text-muted">{{ 'Home.About.WhoWeP2' | translate }}</p>
            <p class="text-muted">{{ 'Home.About.WhoWeP3' | translate }}</p>
            <a routerLink="/signup" class="btn btn-primary mt-3">{{'Home.Signup' |translate }}</a>
          </div>
        </div>
      </div><!--end col-->
    </div><!--end row-->
  </div><!--end container-->
</section><!--end section-->


<section class="section bg-light">
  <div class="container">
    <div class="section-title text-center justify-content-center mb-4 pb-2">
      <h4 class="title mb-4">{{'Home.How.HowItWork' | translate }}</h4>
      <p class="text-muted para-desc mx-auto mb-0">{{'Home.How.p' | translate }}</p>
    </div>

    <div class="row">
      <div class="col-md-4 mt-4 pt-2">
        <div class="card work-process bg-transparent border-0 text-center">
          <div class="icons text-primary text-center mx-auto">
            <img src="../../../../../assets/images/icons/Create.webp">
          </div>

          <div class="card-body">
            <h5 class="text-dark">{{'Home.How.Create' | translate }}</h5>
            <p class="text-muted mb-0">{{'Home.How.CreateP' | translate }}</p>
          </div>
        </div>
      </div><!--end col-->

      <div class="col-md-4 mt-md-5 pt-md-3 mt-4 pt-2">
        <div class="card work-process bg-transparent  border-0 text-center">
          <div class="icons text-primary text-center mx-auto">
            <img src="../../../../../assets/images/icons/Share.webp">
          </div>

          <div class="card-body">
            <h5 class="text-dark">{{'Home.How.Share' | translate }}</h5>
            <p class="text-muted mb-0">{{'Home.How.ShareP' | translate }}</p>
          </div>
        </div>
      </div><!--end col-->

      <div class="col-md-4 mt-md-5 pt-md-5 mt-4 pt-2">
        <div class="card bg-transparent border-0 text-center">
          <div class="icons text-primary text-center mx-auto">
            <img src="../../../../../assets/images/icons/Earn.webp">
          </div>

          <div class="card-body">
            <h5 class="text-dark">{{'Home.How.Earn' | translate }}</h5>
            <p class="text-muted mb-0">{{'Home.How.EarnP' | translate }}</p>
          </div>
        </div>
      </div><!--end col-->
    </div><!--end row-->
  </div><!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row">
      <div class="col-md-8">
        <div class="section-title">
          <h4 class="title mb-4">{{ 'Home.About.WhatWedo' | translate }}</h4>
          <p class="text-muted mb-0 para-desc">{{ 'Home.StartWorking' | translate }} <span
              class="text-primary fw-bold">{{ 'Home.EasyKash' | translate
              }}</span>
            {{ 'Home.SeeEverythingDesc' | translate }}</p>
        </div>
      </div><!--end col-->

    </div><!--end row-->

    <div class="row">
      <div class="col-md-4 mt-4 pt-2">
        <ul class="nav nav-pills nav-justified flex-column bg-white rounded shadow p-3 mb-0 sticky-bar" id="pills-tab"
          role="tablist">
          <li class="nav-item">
            <a class="nav-link rounded active" id="webdeveloping" data-bs-toggle="pill" href="#Integration" role="tab"
              aria-controls="developing" aria-selected="false">
              <div class="text-center py-1">
                <h6 class="mb-0">{{ 'Home.About.Integration' | translate }}</h6>
              </div>
            </a><!--end nav link-->
          </li><!--end nav item-->

          <li class="nav-item mt-2">
            <a class="nav-link rounded" id="webdesigning" data-bs-toggle="pill" href="#PaymentLink" role="tab"
              aria-controls="designing" aria-selected="false">
              <div class="text-center py-1">
                <h6 class="mb-0">{{ 'Home.About.PaymentLink' | translate }}</h6>
              </div>
            </a><!--end nav link-->
          </li><!--end nav item-->

          <li class="nav-item mt-2">
            <a class="nav-link rounded" id="database" data-bs-toggle="pill" href="#POS" role="tab"
              aria-controls="data-analise" aria-selected="false">
              <div class="text-center py-1">
                <h6 class="mb-0">{{ 'Home.About.POS' | translate }}</h6>
              </div>
            </a><!--end nav link-->
          </li><!--end nav item-->

          <li class="nav-item mt-2">
            <a class="nav-link rounded" id="server" data-bs-toggle="pill" href="#Installment" role="tab"
              aria-controls="security" aria-selected="false">
              <div class="text-center py-1">
                <h6 class="mb-0">{{ 'Home.About.Installment' | translate }}</h6>
              </div>
            </a><!--end nav link-->
          </li><!--end nav item-->


        </ul><!--end nav pills-->
      </div><!--end col-->

      <div class="col-md-8 col-12 mt-4 pt-2">
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade bg-white show active p-4 rounded shadow" id="Integration" role="tabpanel"
            aria-labelledby="webdeveloping">
            <img src="../../../../../assets/images/about/intgrartion.png" class="img-fluid rounded shadow" alt="">
            <div class="mt-4">
              <p class="text-muted">{{ 'Home.About.IntegrationDesc' | translate }}</p>
            </div>
          </div><!--end teb pane-->

          <div class="tab-pane fade bg-white p-4 rounded shadow" id="POS" role="tabpanel" aria-labelledby="database">
            <img src="../../../../../assets/images/about/POS.png" class="img-fluid rounded shadow" alt="">
            <div class="mt-4">
              <p class="text-muted"> {{ 'Home.About.POSDesc' | translate }}</p>
            </div>
          </div><!--end teb pane-->

          <div class="tab-pane fade bg-white p-4 rounded shadow" id="Installment" role="tabpanel"
            aria-labelledby="server">
            <img *ngIf="currentLanguages =='ar'" src="../../../../../assets/images/about/installment-Ar.png" class="img-fluid rounded shadow" alt="">
            <img *ngIf="currentLanguages =='en'" src="../../../../../assets/images/about/installment-en.png" class="img-fluid rounded shadow" alt="">

            <div class="mt-4">
              <p class="text-muted">{{ 'Home.About.InstallmentDesc' | translate }}</p>
            </div>
          </div><!--end teb pane-->

          <div class="tab-pane fade bg-white p-4 rounded shadow" id="PaymentLink" role="tabpanel"
            aria-labelledby="webdesigning">
            <img src="../../../../../assets/images/about/payment-link.png" class="img-fluid rounded shadow" alt="">
            <div class="mt-4">
              <p class="text-muted">{{ 'Home.About.PaymentLinkDesc' | translate }}</p>
            </div>
          </div><!--end teb pane-->
        </div><!--end tab content-->
      </div><!--end col-->
    </div><!--end row-->
  </div><!--end container-->
</section><!--end section-->


<!-- Start -->
<section class="section bg-light pt-0">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="video-solution-cta position-relative" style="z-index: 1;">
          <div class="position-relative">
            <img src="../../../../../assets/images/about/about3.png" class="img-fluid rounded-md shadow-lg" alt="">
          </div>
          <div class="content mt-md-4 pt-md-2">
            <div class="row justify-content-center">
              <div class="col-lg-10 text-center">
                <div class="row align-items-center">
                  <div class="col-md-6 mt-4 pt-2">
                    <div class="section-title text-start">
                      <h4 class="title text-white title-dark mb-0">{{ 'Home.About.GrowWise' | translate }}<br>{{ 'Home.About.WithEasykash' | translate }}</h4>
                    </div>
                  </div>

                  <div class="col-md-6 col-12 mt-4 pt-md-2">
                    <div class="section-title text-start">
                      <p class="text-white-50 para-desc">{{ 'Home.About.GrowDesc' | translate }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div><!--end col-->
    </div><!--end row -->
    <div class="feature-posts-placeholder bg-primary bg-gradient"></div>
  </div><!--end container-->
</section><!--end section-->
<!-- End -->


<app-footer></app-footer>
